import {api} from '../../../lib/api';
import type {CompanyConnection,CompanySetup,OrganizationChoices} from './types';

export const companyApi={
  setup:(resourceId:string)=>api<CompanySetup>('getLinkedInCompanySetup',{resourceId}),
  start:(resourceId:string,connectionId?:string)=>api<{url:string}>('startConnection',{senderKind:'organization',resourceId,...(connectionId?{connectionId}:{})}),
  choices:(selectionSessionId:string,cursor?:string)=>api<OrganizationChoices>('listOrganizationChoices',{selectionSessionId,...(cursor?{cursor}:{})}),
  complete:(selectionSessionId:string,organizationUrn:string)=>api<CompanyConnection>('completeOrganizationConnection',{selectionSessionId,organizationUrn}),
  cancel:(selectionSessionId:string)=>api<{cancelled:boolean}>('cancelOrganizationConnection',{selectionSessionId}),
  recheck:(connectionId:string)=>api<CompanyConnection>('recheckConnectionCapabilities',{connectionId}),
};
